import MyRouter from "./components/MyRouter"
import "./index.css"

function App(): JSX.Element {
	return <MyRouter />
}

export default App
